
  import * as ipxRuntime$bS9b5fQIlrXsagDzM7nmVNT2MyIbox8Hi0JnJ8v6_45Kg from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$bS9b5fQIlrXsagDzM7nmVNT2MyIbox8Hi0JnJ8v6_45Kg, defaults: {} }
    }
  }
